export default __webpack_public_path__ + "static/environmentalr-85d9cfd1f675acee40c0f580ad7b99da.jpg";